export class WorkoutCalories {
    constructor(data) {
        Object.defineProperty(this, "workoutCalorieList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "graphScales", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.workoutCalorieList = data.workoutCalorieList.map((v) => new WorkoutCalorie(v));
        this.graphScales = data.graphScales;
    }
}
export class WorkoutCalorie {
    constructor(data) {
        Object.defineProperty(this, "calories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "date", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.calories = data.calories;
        this.date = new Date(data.date * 1000);
    }
}
